import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const AiAgentManagerCreate = () => {
  const [formData, setFormData] = useState({
    agent_name: "",
    role: "",
    status: "",
    data_source_connection: "",
    agent_behavior_prompt: "",
    trigger_events: "",
    last_used: ""
  });

  const [error, setError] = useState(""); // Separate error state
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.agent_name || !formData.role) {
      setError("Agent name and role are required.");
      return;
    }

    fetch(`https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/ai_agent_manager/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(res => {
        if (!res.ok) {
          throw new Error("Failed to submit data");
        }
        return res.json();
      })
      .then(data => {
        toast.success("Data saved successfully!");
        setError("");
        navigate("/ai-agents");
      })
      .catch(err => {
        console.error("Create error:", err);
        setError(err.message || "An unknown error occurred.");
      });
  };

  return (
    <form className='container my-4' onSubmit={handleSubmit}>
      <label>Agent Name</label>
      <input className='form-control mb-3' name="agent_name" value={formData.agent_name} onChange={handleChange} />

      <label>Role</label>
      <input className='form-control mb-3' name="role" value={formData.role} onChange={handleChange} />

      <label>Status</label>
      <input className='form-control mb-3' name="status" value={formData.status} onChange={handleChange} />

      <label>Data Source Connection</label>
      <input className='form-control mb-3' name="data_source_connection" value={formData.data_source_connection} onChange={handleChange} />

      <label>Agent Behavior Prompt</label>
      <input className='form-control mb-3' name="agent_behavior_prompt" value={formData.agent_behavior_prompt} onChange={handleChange} />

      <label>Trigger Events</label>
      <input className='form-control mb-3' name="trigger_events" value={formData.trigger_events} onChange={handleChange} />

      <label>Last Used</label>
      <input className='form-control mb-3' name="last_used" value={formData.last_used} onChange={handleChange} />

      <button className='btn btn-primary me-2' type="submit">Submit</button>
      <button className='btn btn-secondary' type="button" onClick={() => navigate("/ai-agent-manager")}>Cancel</button>

      {error && <div className="mt-3" style={{ color: "red" }}>{error}</div>}
    </form>
  );
};

export default AiAgentManagerCreate;
